// extracted by mini-css-extract-plugin
export default {"main-content":"Tooltip_main-content__8HcjD","main-wrapper":"Tooltip_main-wrapper__bnw14","selected":"Tooltip_selected__ypilD","icon":"Tooltip_icon__bg9WT"};